import {ChangeDetectionStrategy, Component, computed, inject, input, signal, ViewEncapsulation} from '@angular/core';
import {SearchService} from '../../../../services/search/search.service';
import {SearchWidgetThemeEnum} from '../../enums/search-widget-theme.enum';
import {SearchWidgetFreeSearchFieldsEnum} from '../../enums/search-widget-free-search-fields.enum';
import {EventActionEnum, EventCategoryEnum} from '../../../../enums/GaTrackingEnums';
import {GtmEventEnum} from '../../../../enums/GoogleEnums';
import {SearchWidgetManagerService} from '../../../../services/search-widget/search-widget-manager.service';
import {GtmService} from '../../../../services/gtm.service';
import {DLPageTypeEnum} from '../../../../enums/DataLayerEnums';

@Component({
  selector: 'app-search-widget-v4-mobile-expanded',
  templateUrl: './search-widget-v4-mobile-expanded.component.html',
  styleUrls: ['./search-widget-v4-mobile-expanded.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class SearchWidgetV4MobileExpandedComponent {
  public mainCareProviderTypeId = input<number>();
  public inferredCareProviderTypeAreaId = input<number>();
  public inferredCategoryTypeId = input<number>();
  public suggestTypes = input<string[]>([]);
  public pageType = input<DLPageTypeEnum>();
  public placeTerm = signal<string>(null);
  public freeSearchTerm = signal<string>(null);
  public whichIsFocused = signal<SearchWidgetFreeSearchFieldsEnum>(SearchWidgetFreeSearchFieldsEnum.FREESEARCH);
  public whichWasFocused = signal<SearchWidgetFreeSearchFieldsEnum>(SearchWidgetFreeSearchFieldsEnum.FREESEARCH);
  protected readonly SearchWidgetFreeSearchFieldsEnum = SearchWidgetFreeSearchFieldsEnum;
  protected readonly SearchWidgetThemeEnum = SearchWidgetThemeEnum;
  private searchService = inject(SearchService);
  isMobileWidgetExpanded = this.searchService.isMobileWidgetExpanded;
  public state = this.searchService.searchWidgetState;
  public isSubmitButtonActive = computed<boolean>(
    () =>
      this.state() &&
      (this.state().autocompleteValueChanged || this.state().autocompletePlaceValueChanged) &&
      (this.state().autocompleteCurrentValue !== '' || this.state().autocompletePlaceCurrentValue !== ''),
  );

  constructor(
    private gtmService: GtmService,
    private searchWidgetManagerService: SearchWidgetManagerService,
  ) {}

  public onClosePanelClick(): void {
    this.searchService.isMobileWidgetExpanded.set(false);
  }

  public onCategoriesClick(): void {
    this.searchService.mobileCategoriesPanelOpen.set(true);
  }

  public onPlacesClick(): void {
    this.searchService.mobilePlacesPanelOpen.set(true);
  }

  public onFreeSearchFieldFocused(event: boolean): void {
    this.whichIsFocused.set(SearchWidgetFreeSearchFieldsEnum.FREESEARCH);
    this.conditionalSetNewFieldFocus();
  }

  public onPlacesFieldFocused(event: boolean): void {
    this.whichIsFocused.set(SearchWidgetFreeSearchFieldsEnum.PLACE);
    this.conditionalSetNewFieldFocus();
  }

  public searchByLocationClick(): void {
    this.searchWidgetManagerService.registerGtmGa4Event(
      `${EventCategoryEnum.SEARCHNAV} - search by location click`,
      GtmEventEnum.CTA_CLICK,
      this.pageType(),
      this.mainCareProviderTypeId(),
      this.inferredCareProviderTypeAreaId(),
      this.inferredCategoryTypeId(),
    );
    this.searchService.isLocationLoading.set(true);
    this.searchWidgetManagerService.getUserLocation(null, true, false, true);
  }

  public onUpdateFreeSearchSuggestions(event: string): void {
    this.freeSearchTerm.set(event);
  }

  public onUpdatePlacesSuggestions(event: string): void {
    this.placeTerm.set(event);
  }

  public onSubmitClick(event: Event): void {
    const gtmTag = {
      event: GtmEventEnum.DEFAULT,
      Category: EventCategoryEnum.SEARCHNAV,
      Action: EventActionEnum.SEARCH_BUTTON_CLICK,
      Label: 'click',
      Value: 1,
    };
    this.gtmService.pushTag(gtmTag);

    this.searchWidgetManagerService.registerGtmGa4Event(
      `${EventCategoryEnum.SEARCHNAV} - search button click`,
      GtmEventEnum.CTA_CLICK,
      this.pageType(),
      this.mainCareProviderTypeId(),
      this.inferredCareProviderTypeAreaId(),
      this.inferredCategoryTypeId(),
    );

    this.searchWidgetManagerService.searchAction();
  }

  private conditionalSetNewFieldFocus(): void {
    if (this.whichIsFocused() !== this.whichWasFocused()) {
      this.whichWasFocused.set(this.whichIsFocused());
      switch (this.whichIsFocused()) {
        case SearchWidgetFreeSearchFieldsEnum.FREESEARCH:
          this.searchWidgetManagerService.setFocusOnFreeSearchField();
          break;
        case SearchWidgetFreeSearchFieldsEnum.PLACE:
          this.searchWidgetManagerService.setFocusOnPlacesField();
          break;
      }
    }
  }
}
